import React from 'react';
import {Label} from '../../models/Label';
import {LabelTabView} from './LabelTabView';
import {ContentWrapper} from './LabelView.style';
import {isValidText} from '../../utils';
import {t} from 'i18next';
import {Valid} from '../validation/Valid';
import {validateLabelEntryMap} from '../../utils/StorageObjectUtils';
import {generateIdentifier} from '../../utils/IdentityUtils';
import EventEmitter from 'events';
import {LabelView_addAllLocales} from '../../init/events';
import {TemplatePropertySettings} from '../../models/TemplatePropertySettings';
import {isMandatoryComponent, isVisibleComponent} from '../../utils/TemplateUtils';
import {
    STORAGE_OBJECT_OBJECT_LABELS,
    STORAGE_OBJECT_OBJECT_LABELS_DESCRIPTION,
    STORAGE_OBJECT_OBJECT_LABELS_NAME,
    STORAGE_OBJECT_OBJECT_METADATA,
    STORAGE_OBJECT_OBJECT_METADATA_VERSION
} from '../../init/storage_object_constants';

export interface LabelsViewProps {
    readonly templatePropertySettings: Map<string, TemplatePropertySettings>;
    readonly defaultLocale: string;
    readonly labels: Map<string, Label>;
    readonly version: string;
    readonly parentLocales: string[];
    readonly eventEmitter: EventEmitter;
    onLabelsChange: (labels: Map<string, Label>) => void;
    onVersionChange: (version: string) => void;
    onAddAllLabels: () => void;
    onReset: () => void;
}

/**
 * @name LabelView
 * @description
 * Component wrapper per StorageObject Labels
 */
export const LabelView: React.VFC<LabelsViewProps> = (props) => {
    const handleChangeLabels = (labels: Map<string, Label>) => {
        props.onLabelsChange(labels);
    };

    const handleChangeVersion = (version: string) => {
        props.onVersionChange(version);
    };

    const handleAddAllLabels = () => {
        props.onAddAllLabels();
    };

    const handleReset = () => {
        props.onReset();
    };

    const isValidLabelTabView = (): boolean => {
        return ((isMandatoryComponent(STORAGE_OBJECT_OBJECT_METADATA_VERSION, props.templatePropertySettings) ? isValidText(props.version) : true)
            && validateLabelEntryMap(props.labels, props.templatePropertySettings)) as boolean;
    };

    props.eventEmitter.on(LabelView_addAllLocales, handleChangeLabels);

    return (
        <ContentWrapper id={generateIdentifier()}>
            {((isVisibleComponent(STORAGE_OBJECT_OBJECT_LABELS, props.templatePropertySettings)
                        && (isVisibleComponent(STORAGE_OBJECT_OBJECT_LABELS_NAME, props.templatePropertySettings)
                            || isVisibleComponent(STORAGE_OBJECT_OBJECT_LABELS_DESCRIPTION, props.templatePropertySettings)))
                    || (isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA, props.templatePropertySettings)
                        && isVisibleComponent(STORAGE_OBJECT_OBJECT_METADATA_VERSION, props.templatePropertySettings))) &&
                <Valid
                    isValid={(isMandatoryComponent(STORAGE_OBJECT_OBJECT_LABELS, props.templatePropertySettings) ? isValidLabelTabView() : true)}
                    message={t('META_DATA_DIALOG_LABEL_TAB_NOT_VALID_CONSTRAINT')}>
                    <LabelTabView templatePropertySettings={props.templatePropertySettings}
                                  defaultLocale={props.defaultLocale}
                                  labels={props.labels}
                                  version={props.version}
                                  parentLocales={props.parentLocales}
                                  onChangeLabels={handleChangeLabels}
                                  onChangeVersion={handleChangeVersion}
                                  onAddAllLabels={handleAddAllLabels}
                                  onReset={handleReset}/>
                </Valid>
            }
        </ContentWrapper>
    );
};
